import EncounterServiceTypeValueSet from "@/fhir/seed-data/value-sets/qh-encounter-service-type.json";
import { joinTokenString } from "@/utils/medplum";

/** One filter option, keyed by a ValueSet concept's own `code` and labeled by its `display`. */
export interface EncounterTypeFilterOption {
  key: string;
  label: string;
}

function getEncounterTypeConcepts() {
  return EncounterServiceTypeValueSet.compose.include.flatMap((include) =>
    include.concept.map((concept) => ({
      key: concept.code,
      label: concept.display,
      token: joinTokenString(include.system, concept.code)!,
    })),
  );
}

/**
 * The Missing Services Encounter-type filter's option list (key + label), read straight from
 * `qh-encounter-service-type.json` — the same ValueSet the create/amend Encounter forms bind their
 * Template picker to. There is nothing to hand-maintain here: add a concept to the ValueSet and it
 * shows up as a filter option on its own.
 */
export function getEncounterTypeFilterOptions(): EncounterTypeFilterOption[] {
  return getEncounterTypeConcepts().map(({ key, label }) => ({ key, label }));
}

/**
 * The `system|code` token each Missing Services Encounter-type filter key matches on `meta.tag`,
 * mirrored there by `create-encounter.ts` since `Encounter.serviceType` has no search parameter of
 * its own. Looked up from the ValueSet above rather than hand-typed, so the filter can't drift from
 * the codes the create/amend forms actually write.
 */
export function getEncounterTypeFilterTags(): Record<string, string[]> {
  return getEncounterTypeConcepts().reduce<Record<string, string[]>>((tags, concept) => {
    tags[concept.key] = [concept.token];
    return tags;
  }, {});
}
